import SubscriptionEdit from './SubscriptionEdit';

export default {
  edit: SubscriptionEdit,
};
